import DirectionServicesView from '@/components/DirectionServicesView';

export default function SubDirectionPage(props) {
   const {id, title, direction, directions, banner = {}, banner_alt, short_content, services, current_direction, blocks, questions, h1, gallery } = props;
   const image = {
    desktop: banner?.main_page_desktop,
    tablet: banner?.main_page_tablet,
    mobile: banner?.main_page_mobile,
  };

  const subdirectionBanner = {
    id,
    title: h1 || title,
    image,
    banner_alt,
    theme: 'dark',
  };

  return (
    <DirectionServicesView
      banners={[subdirectionBanner]}
      directions={directions}
      short_content={short_content}
      services={services}
      blocks={blocks}
      questions={questions}
      current_direction={current_direction}
      activeSlug={direction?.slug}
      gallery={gallery}
    />
  );
}
